import { useToast } from '@chakra-ui/react';
import { FaEye, FaEyeSlash, FaAndroid } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import { Encrypt } from '../../utils/constants';
import { useState } from 'react';
import { loginAPI } from '../../service/AuthService';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './login.scss';

const PROMO_IMAGE = 'https://reddybook.live/assets/images/log_one.png';

export default function LoginCard({ onClose }) {
  const navigate = useNavigate();
  const toast = useToast();
  const dispatch = useDispatch();
  const rememberedUser = localStorage.getItem('rememberedUser') || '';
  const [userName, setUserName] = useState(rememberedUser);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(!!rememberedUser);
  const [isLoading, setIsLoading] = useState(false);
  const [isDemoLoading, setIsDemoLoading] = useState(false);

  const loginHandler = async () => {
    if (!userName || !password) {
      return toast({
        title: 'Warning',
        description: 'Please enter username and password',
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
    }

    setIsLoading(true);
    try {
      const res = await loginAPI(userName, Encrypt(password));
      const resData = res.data;

      if (resData.code === 200) {
        if (resData.response.mfaEnabled) {
          return navigate(`/loginauth/2?user=${userName}`);
        }
        localStorage.setItem('token', resData?.response?.token);
        localStorage.setItem('refCode', resData?.response?.refferalCode || '');
        localStorage.setItem('user', JSON.stringify(resData?.response.username));

        if (rememberMe) {
          localStorage.setItem('rememberedUser', userName);
        } else {
          localStorage.removeItem('rememberedUser');
        }

        dispatch({
          type: 'accountData/setUserData',
          payload: resData?.response,
        });
        toast({
          title: 'Success',
          description: 'Login successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        if (onClose) {
          onClose();
        } else {
          navigate('/');
        }
      } else {
        toast({
          title: 'Error',
          description: resData?.response || resData?.error || 'Something went wrong',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch {
      toast({
        title: 'Error',
        description: 'Something went wrong. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const demoLoginHandler = async () => {
    setIsDemoLoading(true);
    try {
      const res = await loginAPI('DEMO', Encrypt('Test@123'));
      const resData = res.data;

      if (resData.code === 200) {
        localStorage.setItem('token', resData?.response?.token);
        localStorage.setItem('refCode', resData?.response?.refferalCode || '');
        localStorage.setItem('user', JSON.stringify(resData?.response.username));
        dispatch({
          type: 'accountData/setUserData',
          payload: resData?.response,
        });
        toast({
          title: 'Success',
          description: 'Demo login successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        if (onClose) {
          onClose();
        } else {
          navigate('/');
        }
      } else {
        toast({
          title: 'Error',
          description: 'Demo login not available',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch {
      toast({
        title: 'Error',
        description: 'Demo login not available',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDemoLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      loginHandler();
    }
  };

  return (
    <section className="login-overlay" role="dialog" aria-modal="true" aria-label="Login" onClick={() => onClose ? onClose() : navigate('/')}>
      <article className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="login-modal__close"
          onClick={() => onClose ? onClose() : navigate('/')}
          aria-label="Close login dialog"
          type="button"
        >
          <IoClose />
        </button>

        {/* Left Side - Form */}
        <div className="login-modal__form">
          <label className="login-modal__form-label" htmlFor="login-username">
            Username / Mobile Number
          </label>
          <div className="login-modal__form-input-wrapper">
            <input
              id="login-username"
              className="login-modal__form-input"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="username"
            />
          </div>

          <label className="login-modal__form-label" htmlFor="login-password">
            Password
          </label>
          <div className="login-modal__form-input-wrapper">
            <input
              id="login-password"
              className="login-modal__form-input"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="current-password"
              style={{ paddingRight: '42px' }}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="login-modal__remember-row">
            <input
              type="checkbox"
              id="remember-me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="remember-me">Remember Me?</label>
          </div>

          {/* <span
            className="login-modal__forgot-link"
            onClick={() => navigate('/forgot-password')}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate('/forgot-password')}
          >
            Forgot Password/Username?
          </span> */}

          <button
            className="login-modal__btn login-modal__btn--login"
            onClick={loginHandler}
            disabled={isLoading || isDemoLoading}
            type="button"
          >
            {isLoading ? 'LOGGING IN...' : 'LOG IN'}
          </button>

          <button
            className="login-modal__btn login-modal__btn--demo"
            onClick={demoLoginHandler}
            disabled={isLoading || isDemoLoading}
            type="button"
          >
            {isDemoLoading ? 'LOGGING IN...' : 'LOGIN WITH DEMO ID'}
          </button>

          {/* <button
            className="login-modal__btn login-modal__btn--apk"
            type="button"
            onClick={() => toast({
              title: 'Info',
              description: 'APK download coming soon',
              status: 'info',
              duration: 3000,
              isClosable: true,
            })}
          >
            Download APK <FaAndroid />
          </button> */}

          <div className="login-modal__footer">
            <p className="login-modal__footer-text">
              Powered By{' '}
              <span className="login-modal__footer-text--brand">IndoExch</span>
            </p>
            {/* <p className="login-modal__footer-text login-modal__footer-text--email">
              IndoExch.official@Gmail.Com
            </p> */}
          </div>
        </div>

        {/* Right Side - Promotional Image */}
        <div className="login-modal__image">
          <img src={PROMO_IMAGE} alt="Sports Book" />
        </div>
      </article>
    </section>
  );
}
